var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddplus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#0071E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 13.25H8C7.7875 13.25 7.6095 13.178 7.466 13.034C7.3225 12.89 7.2505 12.712 7.25 12.5C7.2495 12.288 7.3215 12.11 7.466 11.966C7.6105 11.822 7.7885 11.75 8 11.75H11.75V8C11.75 7.7875 11.822 7.6095 11.966 7.466C12.11 7.3225 12.288 7.2505 12.5 7.25C12.712 7.2495 12.8903 7.3215 13.0348 7.466C13.1793 7.6105 13.251 7.7885 13.25 8V11.75H17C17.2125 11.75 17.3908 11.822 17.5348 11.966C17.6788 12.11 17.7505 12.288 17.75 12.5C17.7495 12.712 17.6775 12.8903 17.534 13.0348C17.3905 13.1793 17.2125 13.251 17 13.25H13.25V17C13.25 17.2125 13.178 17.3908 13.034 17.5348C12.89 17.6788 12.712 17.7505 12.5 17.75C12.288 17.7495 12.11 17.6775 11.966 17.534C11.822 17.3905 11.75 17.2125 11.75 17V13.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddplus);
export default __webpack_public_path__ + "static/media/addplus.5b3e3838de3e498d9b1f4fe08e614e8c.svg";
export { ForwardRef as ReactComponent };